export const isBlockingProcessesExists = state => {
  return state.common.uiBlockingProcesses.length > 0;
};



// WEBPACK FOOTER //
// ./src/modules/common/common-selectors.js